import React, { FC } from 'react';

import { ArticlePortableText } from 'styled';
import ArticleBodySwitch from 'components/ArticleBodyModuleSwitch';
import ArticleNav from 'components/ArticleNav';

import { ArticleGenericPage as IArticleGenericPage } from 'types';

interface Props {
  page: IArticleGenericPage;
}

const ArticleGenericPage: FC<Props> = ({ page }) => {
  return (
    <div className="ArticleGenericPage sm:flex">
      <ArticleNav article={page} />
      <ArticlePortableText
        textColor="gray-dark"
        className="ArticleGenericPage__content overflow-x-hidden article-content-padding mt4 md:mt6"
      >
        <ArticleBodySwitch modules={page.bodyModules} />
      </ArticlePortableText>
    </div>
  );
};

export default ArticleGenericPage;
